/** Decimal age in years at `onDate` (ISO dates), 2 decimals as the legacy program stored it. */
export function decimalAge(dob: string, onDate: string): number {
  const ms = Date.parse(`${onDate}T00:00:00Z`) - Date.parse(`${dob}T00:00:00Z`);
  return Math.round((ms / 86_400_000 / 365.25) * 100) / 100;
}
